import { Controller } from '@hotwired/stimulus'
import 'utils/multiselect' // side-effect: registers prod's global .multiselect driver (open/close/select/label)

// /case-studies grid: Category + Industry multi-select filters and "Show all".
// Same model as data_sets_gallery_filter: within a filter values OR, across
// filters AND, none checked = All. Each multiselect names its dimension in
// data-multiselect-dim; a card carries the matching data-<dim> value.
// Attached to .case-studies-list via data-controller="case-studies-filter".
export default class extends Controller {
  static targets = ['card', 'showMore']
  static values = { visibleCount: { type: Number, default: 6 } }

  connect() {
    this.filters = Array.from(
      this.element.querySelectorAll('.multiselect[data-multiselect-dim]')
    )
    this.showAll = false

    // The prod multiselect driver toggles the checkboxes; we react to their change.
    this.onChange = e => {
      if (e.target.classList?.contains('multiselect__checkbox')) {
        this.showAll = false
        this.render()
      }
    }
    // "Clear All" unchecks without a change event → resync on its click.
    this.onClear = e => {
      if (e.target.closest('.multiselect__clear')) {
        requestAnimationFrame(() => {
          this.showAll = false
          this.render()
        })
      }
    }
    this.element.addEventListener('change', this.onChange)
    this.element.addEventListener('click', this.onClear)

    this.render()
  }

  disconnect() {
    this.element.removeEventListener('change', this.onChange)
    this.element.removeEventListener('click', this.onClear)
  }

  matches(card) {
    return this.filters.every(filter => {
      const checked = Array.from(
        filter.querySelectorAll('.multiselect__checkbox:checked'),
        c => c.value
      )
      return (
        checked.length === 0 ||
        checked.includes(card.dataset[filter.dataset.multiselectDim])
      )
    })
  }

  render() {
    let matched = 0
    this.cardTargets.forEach(card => {
      const ok = this.matches(card)
      card.hidden = !ok || (!this.showAll && matched >= this.visibleCountValue)
      if (ok) matched++
    })
    this.showMoreTarget.hidden =
      this.showAll || matched <= this.visibleCountValue
  }

  showMore() {
    this.showAll = true
    this.render()
  }
}
